module.exports = __webpack_public_path__ + "assets/img/home-bg@2x.a195bc28.png";